var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full max-w-full md:w-168 lg:w-168 xl:w-192 h-full aspect-video"})
}
var staticRenderFns = []

export { render, staticRenderFns }